import * as React from "react";
import { Check } from "lucide-react";
import { cn } from "@/lib/cn";

export interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {}

/**
 * Checkbox — Volume 03 §5. Nhiều lựa chọn độc lập.
 * Vùng click gồm cả label (bọc trong <label>).
 */
export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, ...props }, ref) => (
    <span className="relative inline-flex">
      <input
        ref={ref}
        type="checkbox"
        className={cn(
          "peer size-5 shrink-0 appearance-none rounded-xs border border-border-strong bg-surface",
          "transition-colors duration-fast ease-out",
          "checked:border-primary checked:bg-primary",
          "focus-visible:outline-none focus-visible:ring focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-canvas",
          "disabled:cursor-not-allowed disabled:bg-subtle",
          className
        )}
        {...props}
      />
      <Check
        className="pointer-events-none absolute left-0.5 top-0.5 size-4 text-white opacity-0 peer-checked:opacity-100"
        aria-hidden="true"
        strokeWidth={3}
      />
    </span>
  )
);
Checkbox.displayName = "Checkbox";
